import { ERoleExtraIsBuyer } from '../../enum'

// Create a union type of all possible values from the enum
type IRoleExtraIsBuyerLangKey = `${ERoleExtraIsBuyer}`

export type IRoleExtraIsBuyerLang = {
	role_extra_is_buyer: Record<IRoleExtraIsBuyerLangKey, string>
}

const langEntries = Object.entries(ERoleExtraIsBuyer).map(
	([key, value]) => [value, `role_extra_is_buyer.${value}`]
)

const langObj: Record<IRoleExtraIsBuyerLangKey, string> = Object.fromEntries(langEntries)

export const ROLE_EXTRA_IS_BUYER_LANG_KEY: IRoleExtraIsBuyerLang = {
	role_extra_is_buyer: langObj
}
